"use client";

import { Formik } from "formik";

import UserForm from "@/components/templates/UserForm";
import {
  buildUserFormInitialData,
  buildUserFormSchema,
  normalizeUserFormData,
} from "@/components/templates/UserForm/form-data";
import { UserFormData } from "@/components/templates/UserForm/types";
import SWR_KEYS from "@/constants/swr-keys";
import useAuth from "@/contexts/auth-context";
import useUpdateUser from "@/hooks/requests/user/use-update-user";
import useLoading from "@/hooks/use-loading";
import useMutate from "@/hooks/use-mutate";
import IUser from "@/interfaces/user.interface";
import { ProfileMessages } from "@/messages/profile/profile.messages";

type Props = {
  messages: ProfileMessages;
  user: IUser;
};

function UpdateProfile({ messages, user }: Props) {
  const { mutate } = useMutate();
  const { setUser, user: userAuth } = useAuth();
  const { update, isLoading: isLoadingUpdate } = useUpdateUser();
  const { startLoading, endLoading, isLoading } = useLoading();

  // const { updateUserError: errorMessage, updateUserSuccess: successMessage } = messages;

  const handleUpdateUser = async (_formData: UserFormData) => {
    try {
      startLoading();
      const formData = normalizeUserFormData(_formData);
      const _id = user.id;

      await update({ formData, _id });
      await mutate(SWR_KEYS.getUserById);

      if (userAuth) {
        setUser({ ...userAuth, enableSoundNotification: formData.enableSoundNotification });
      }
    } catch (_error) {
      // erro já será tratado por mensagens do serviço
    } finally {
      endLoading();
    }
  };

  const isLoadingForm = isLoading || isLoadingUpdate;

  return (
    <Formik
      initialValues={buildUserFormInitialData(user)}
      validationSchema={buildUserFormSchema(messages)}
      validateOnChange={false}
      onSubmit={handleUpdateUser}
    >
      <UserForm messages={messages} isLoading={isLoadingForm} isEditing isProfile />
    </Formik>
  );
}

export default UpdateProfile;
